"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobStorageApiService = void 0;
var browser_services_1 = require("@seismic/browser-services");
/**
 * Service to handle uploading files to Blob Storage Service
 */
var BlobStorageApiService = /** @class */ (function () {
    function BlobStorageApiService(httpService, sdsService, tenantService) {
        this.httpService = httpService;
        this.sdsService = sdsService;
        this.tenantService = tenantService;
    }
    /**
     * Upload a file to Blob Storage Service
     * @param {File} file
     * @param {IBlobStorageApiServiceUploadOptions} options
     * @return {Promise<IBlobStorageApiUploadResponse>} response
     */
    BlobStorageApiService.prototype.uploadFile = function (file, options) {
        return __awaiter(this, void 0, void 0, function () {
            var bssServiceAddress, url, optionsWithDefaults, chunkSizeInBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sdsService.getServiceAddressByKey('bss')];
                    case 1:
                        bssServiceAddress = _a.sent();
                        url = "".concat(bssServiceAddress, "/api/upload/v1/blobs");
                        optionsWithDefaults = this.getOptionsWithDefaults(file, options);
                        chunkSizeInBytes = optionsWithDefaults.chunkSizeInMB * 1024 * 1024;
                        if (file.size > chunkSizeInBytes) {
                            return [2 /*return*/, this.chunkUpload(url, file, optionsWithDefaults)];
                        }
                        else {
                            return [2 /*return*/, this.upload(url, file, optionsWithDefaults)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BlobStorageApiService.prototype.getOptionsWithDefaults = function (file, options) {
        var _a, _b, _c;
        var MINIMUM_CHUNK_SIZE = 5;
        var MAXIMUM_CHUNK_SIZE = 100;
        var DEFAULT_CHUNK_SIZE = 20;
        if (options.chunkSizeInMB && (options.chunkSizeInMB < MINIMUM_CHUNK_SIZE || options.chunkSizeInMB > MAXIMUM_CHUNK_SIZE)) {
            throw new Error('chunkSizeInMB must be between 5 and 100');
        }
        var chunkSizeInMB = options.chunkSizeInMB || DEFAULT_CHUNK_SIZE;
        var blobMetadata = {
            filename: ((_a = options.blobMetadata) === null || _a === void 0 ? void 0 : _a.filename) || file.name.split('.')[0] || '',
            format: ((_b = options.blobMetadata) === null || _b === void 0 ? void 0 : _b.format) || file.name.split('.')[1] || '',
            expiration: (_c = options.blobMetadata) === null || _c === void 0 ? void 0 : _c.expiration, // Default: -1 (never expire), @see IBlobStorageApiServiceUploadBlobMetadata.expiration
        };
        return __assign(__assign({}, options), { chunkSizeInMB: chunkSizeInMB, blobMetadata: blobMetadata });
    };
    /**
     * Get the majority of the headers for Upload request and Complete Chunk Upload request
     */
    BlobStorageApiService.prototype.getCompleteUploadHeaders = function (options) {
        return {
            'x-seismic-blob-metadata': JSON.stringify(options.blobMetadata),
            'x-seismic-blob-owner': options.owner,
            'x-seismic-blob-virus-scan-extra-info': options.blobVirusScanExtraInfo || '',
            'x-client-application-name': options.applicationName || '',
            'x-client-application-version': options.applicationVersion || '',
        };
    };
    BlobStorageApiService.prototype.upload = function (url, file, options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_a = options.progressCallback) === null || _a === void 0 ? void 0 : _a.call(options, 0);
                        return [4 /*yield*/, this.httpService.post(url, file, {
                                progressCallback: options.progressCallback,
                                query: {
                                    t: this.tenantService.getTenantName(),
                                    c: options.container,
                                    isfullcontainername: options.isFullContainerName,
                                },
                                headers: this.getCompleteUploadHeaders(options),
                            })];
                    case 1:
                        response = _c.sent();
                        (_b = options.progressCallback) === null || _b === void 0 ? void 0 : _b.call(options, 100);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    BlobStorageApiService.prototype.chunkUpload = function (url, file, options) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var tenant, chunkSizeInBytes, chunkIds, startUploadInfo, totalChunks, chunkIndex, startByteIndex, endByteIndex, isLast, response, completeResponse;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        tenant = this.tenantService.getTenantName();
                        chunkSizeInBytes = options.chunkSizeInMB * 1024 * 1024;
                        chunkIds = [];
                        return [4 /*yield*/, this.startChunkUpload(tenant, options)];
                    case 1:
                        startUploadInfo = _d.sent();
                        (_a = options.progressCallback) === null || _a === void 0 ? void 0 : _a.call(options, 0);
                        totalChunks = Math.ceil(file.size / chunkSizeInBytes);
                        chunkIndex = 0;
                        _d.label = 2;
                    case 2:
                        if (!(chunkIndex < totalChunks)) return [3 /*break*/, 5];
                        startByteIndex = chunkSizeInBytes * chunkIndex;
                        endByteIndex = startByteIndex + chunkSizeInBytes;
                        isLast = chunkIndex === totalChunks - 1;
                        return [4 /*yield*/, this.httpService.post(url, file.slice(startByteIndex, endByteIndex), {
                                progressCallback: options.progressCallback,
                                query: {
                                    t: this.tenantService.getTenantName(),
                                    action: 'append',
                                    index: chunkIndex,
                                    islast: isLast.toString(),
                                },
                                headers: {
                                    'x-seismic-upload-info': startUploadInfo.encoded,
                                    'x-client-application-name': options.applicationName || '',
                                    'x-client-application-version': options.applicationVersion || '',
                                },
                            })];
                    case 3:
                        response = _d.sent();
                        // Wait for the end chunk upload response to set progress to 100%
                        if (!isLast) {
                            (_b = options.progressCallback) === null || _b === void 0 ? void 0 : _b.call(options, (chunkIndex + 1) / totalChunks);
                        }
                        chunkIds.push(response['x-seismic-upload-info']);
                        _d.label = 4;
                    case 4:
                        chunkIndex++;
                        return [3 /*break*/, 2];
                    case 5: return [4 /*yield*/, this.endChunkUpload(file, chunkIds, tenant, options)];
                    case 6:
                        completeResponse = _d.sent();
                        (_c = options.progressCallback) === null || _c === void 0 ? void 0 : _c.call(options, 100);
                        return [2 /*return*/, completeResponse];
                }
            });
        });
    };
    /**
     * Complete Chunk Upload
     * @see [BSS Docs: Start Chunk Upload](https://seismic.atlassian.net/wiki/spaces/PLATFORM/pages/1088067253/Blob+Storage+Service+API+Specification#BlobStorageServiceAPISpecification-StartChunkUploadstartupload)
     */
    BlobStorageApiService.prototype.startChunkUpload = function (tenant, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, _a, startUploadResponse, uploadInfo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = "".concat;
                        return [4 /*yield*/, this.sdsService.getServiceAddressByKey('bss')];
                    case 1:
                        url = _a.apply("", [_b.sent(), "/api/upload/v1/blobs"]);
                        return [4 /*yield*/, this.httpService.post(url, {}, // Empty body on start
                            {
                                query: {
                                    t: tenant,
                                    c: options.container,
                                    action: 'start',
                                    chunkSize: options.chunkSizeInMB,
                                    isfullcontainername: options.isFullContainerName,
                                },
                                headers: {
                                    'x-client-application-name': options.applicationName || '',
                                    'x-client-application-version': options.applicationVersion || '',
                                },
                            })];
                    case 2:
                        startUploadResponse = _b.sent();
                        uploadInfo = JSON.parse(atob(startUploadResponse['x-seismic-upload-info']));
                        return [2 /*return*/, { data: uploadInfo, encoded: startUploadResponse['x-seismic-upload-info'] }];
                }
            });
        });
    };
    /**
     * Complete Chunk Upload
     * @see [BSS Docs: Complete Chunk Upload](https://seismic.atlassian.net/wiki/spaces/PLATFORM/pages/1088067253/Blob+Storage+Service+API+Specification#BlobStorageServiceAPISpecification-CompleteChunkUploadfinishupload)
     */
    BlobStorageApiService.prototype.endChunkUpload = function (file, base64EncodedUploadInfos, tenant, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = "".concat;
                        return [4 /*yield*/, this.sdsService.getServiceAddressByKey('bss')];
                    case 1:
                        url = _a.apply("", [_b.sent(), "/api/upload/v1/blobs"]);
                        return [2 /*return*/, this.httpService.post(url, base64EncodedUploadInfos, {
                                query: {
                                    t: tenant,
                                    action: 'commit',
                                },
                                headers: this.getCompleteUploadHeaders(options),
                            })];
                }
            });
        });
    };
    BlobStorageApiService = __decorate([
        (0, browser_services_1.CommonService)('BlobStorageApi'),
        __metadata("design:paramtypes", [browser_services_1.HttpService,
            browser_services_1.ServiceAddressService,
            browser_services_1.TenantService])
    ], BlobStorageApiService);
    return BlobStorageApiService;
}());
exports.BlobStorageApiService = BlobStorageApiService;
//# sourceMappingURL=BlobStorageApi.service.js.map